package com.hyperether.goodjob.database

import kotlin.Long
import kotlin.String

public data class User(
  public val id: Long,
  public val _id: String?,
  public val fullName: String?,
  public val email: String?,
  public val password: String?,
  public val confirmStatus: String?,
  public val role: String?,
  public val workspace_ids: String?,
  public val planId: String?,
  public val phone: String?,
  public val city: String?,
  public val contry: String?,
  public val zip: String?,
  public val address: String?,
  public val status: String?,
  public val skills: String?,
  public val teams: String?,
  public val customerId: String?,
  public val upcomingLeave: String?,
  public val workingHours: String?,
  public val pendingPlanId: String?,
  public val subscriptionEndsAt: String?,
  public val lang: String?,
)
